// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__21NcZ","label":"Section_label__3pwqC","contentWrap":"Section_contentWrap__3LWBA","footer":"Section_footer__3Z0pW","footerInner":"Section_footerInner__1Z0zD"};